<template>
  <div>
    <h5 v-if="content.language == 'de-CH'">
      Deutsch
    </h5>
    <h5 v-if="content.language == 'fr-CH'">
      Französisch
    </h5>
    <h5 v-if="content.language == 'it-CH'">
      Italienisch
    </h5>

    <h6>Beschreibung</h6>
    <translation-text-field
      :value="content.value"
      :language="content.language"
      :can-user-edit="canUserEdit"
      @update:value="content.value = $event"
      @updateValidation="updateValidation()"
    />
    <h6>Link</h6>
    <translation-text-field
      :value="content.url"
      :language="content.language"
      :can-user-edit="canUserEdit"
      @update:value="content.url = $event"
      @updateValidation="updateValidation()"
    />
    <v-alert
      v-if="(content.value && !content.url) || (!content.value && content.url)"
      :value="true"
      type="error"
      outline
    >
      Bei der Erfassung des Links, muss der Link und die Beschreibung erfasst
      werden.
    </v-alert>
    <hr>
  </div>
</template>

<script>
import TranslationTextField from "./EditionTranslations_TextField";

// import { LoadAllCriterionConfigurations } from "@/services/criterion.management.service.js";
export default {
  components: {
    TranslationTextField,
  },
  props: {
    canUserEdit: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    updateValidation() {
      this.$emit("updateValidation");
    },
  },
};
</script>

<style>
.secoundPanel .v-expansion-panel__header {
  background-color: white !important;
  background: white !important;
  color: black !important;
  border-bottom: 1px solid #808080 !important;
}

.objectCard {
  border: 1px solid rgba(204, 204, 204, 0.5) !important;
  border-radius: 4px !important;
  background: rgba(204, 204, 204, 0.1) !important;
}
</style>
